import script from "./ExperienceInRestaurantServices.vue?vue&type=script&lang=js"
export * from "./ExperienceInRestaurantServices.vue?vue&type=script&lang=js"

import "./ExperienceInRestaurantServices.vue?vue&type=style&index=0&id=3bb8a61e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb8a61e"]])

export default __exports__